import connectRange from "instantsearch.js/es/connectors/range/connectRange.js";
import { useConnector } from "../hooks/useConnector.js";
export function useRange(props, additionalWidgetProperties) {
  return useConnector(connectRange, props, additionalWidgetProperties);
}